import styled from 'styled-components';
import { FONTS, SIZE, COLORS } from '@app/src/ui';
import { Button } from '@app/src/common/Button';

export const TermsAndConditions = styled.p`
  font-size: 12px;
  margin-left: 8px;
  width: 90%;

  a {
    font-size: 12px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;

    a {
      font-size: 14px;
    }
  }
`;

export const FormWrapper = styled.form`
  padding: 0 40px;
  max-width: 360px;
  margin: 0 auto;
  font-family: ${FONTS.OPEN_SANS};
`;

export const Title = styled.h2`
  font-size: 16px;
  margin: 24px 0;
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
  }
`;

export const ButtonLogin = styled(Button)`
  margin: 37px auto 16px;
`;

export const Session = styled.p`
  font-size: 12px;
  text-align: center;
  margin-bottom: 20px;
  a {
    color: blue;
    font-size: 12px;
    cursor: pointer;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;

    a {
      font-size: 14px;
    }
  }
`;

export const FieldWrapper = styled.div`
  margin-bottom: 16px;
`;

export const IconMail = styled.i`
  position: absolute;
  left: 13px;
  top: 11px;
`;

export const ButtonGoBack = styled.a`
  left: 0;
  font-size: 15px;
  font-family: ${FONTS.ROBOTO_BOLD};
  color: ${COLORS.BLACK_BOLD};
  display: flex;
  margin-left: 15px;
  margin-top: 15px;

  svg {
    margin-right: 4px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
    position: absolute;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  position: relative;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
  }
`;